module.exports = __webpack_public_path__ + "static/media/image.a9a4978c.svg";